/* */ 
(function(process) {
  "use strict";
  require('./Polyfills');
  var get = require('lodash.get');
  var Report = require('./Report');
  var FormatValidators = require('./FormatValidators');
  var JsonValidation = require('./JsonValidation');
  var SchemaCache = require('./SchemaCache');
  var SchemaCompilation = require('./SchemaCompilation');
  var SchemaValidation = require('./SchemaValidation');
  var Utils = require('./Utils');
  var Draft4Schema = require('./schemas/schema.json!systemjs-json');
  var Draft4HyperSchema = require('./schemas/hyper-schema.json!systemjs-json');
  var defaultOptions = {
    asyncTimeout: 2000,
    forceAdditional: false,
    assumeAdditional: false,
    forceItems: false,
    forceMinItems: false,
    forceMaxItems: false,
    forceMinLength: false,
    forceMaxLength: false,
    forceProperties: false,
    ignoreUnresolvableReferences: false,
    noExtraKeywords: false,
    noTypeless: false,
    noEmptyStrings: false,
    noEmptyArrays: false,
    strictUris: false,
    strictMode: false,
    reportPathAsArray: false,
    breakOnFirstError: true,
    pedanticCheck: false,
    ignoreUnknownFormats: false,
    customValidator: null
  };
  function ZSchema(options) {
    this.cache = {};
    this.referenceCache = [];
    this.setRemoteReference("http://json-schema.org/draft-04/schema", Draft4Schema);
    this.setRemoteReference("http://json-schema.org/draft-04/hyper-schema", Draft4HyperSchema);
    if (typeof options === "object") {
      var keys = Object.keys(options),
          idx = keys.length,
          key;
      while (idx--) {
        key = keys[idx];
        if (defaultOptions[key] === undefined) {
          throw new Error("Unexpected option passed to constructor: " + key);
        }
      }
      keys = Object.keys(defaultOptions);
      idx = keys.length;
      while (idx--) {
        key = keys[idx];
        if (options[key] === undefined) {
          options[key] = Utils.clone(defaultOptions[key]);
        }
      }
      this.options = options;
    } else {
      this.options = Utils.clone(defaultOptions);
    }
    if (this.options.strictMode === true) {
      this.options.forceAdditional = true;
      this.options.forceItems = true;
      this.options.forceMaxLength = true;
      this.options.forceProperties = true;
      this.options.noExtraKeywords = true;
      this.options.noTypeless = true;
      this.options.noEmptyStrings = true;
      this.options.noEmptyArrays = true;
    }
  }
  ZSchema.prototype.compileSchema = function(schema) {
    var report = new Report(this.options);
    schema = SchemaCache.getSchema.call(this, report, schema);
    SchemaCompilation.compileSchema.call(this, report, schema);
    this.lastReport = report;
    return report.isValid();
  };
  ZSchema.prototype.validateSchema = function(schema) {
    if (Array.isArray(schema) && schema.length === 0) {
      throw new Error(".validateSchema was called with an empty array");
    }
    var report = new Report(this.options);
    schema = SchemaCache.getSchema.call(this, report, schema);
    var compiled = SchemaCompilation.compileSchema.call(this, report, schema);
    if (compiled) {
      SchemaValidation.validateSchema.call(this, report, schema);
    }
    this.lastReport = report;
    return report.isValid();
  };
  ZSchema.prototype.validate = function(json, schema, options, callback) {
    if (Utils.whatIs(options) === "function") {
      callback = options;
      options = {};
    }
    if (!options) {
      options = {};
    }
    var whatIs = Utils.whatIs(schema);
    if (whatIs !== "string" && whatIs !== "object") {
      var e = new Error("Invalid .validate call - schema must be an string or object but " + whatIs + " was passed!");
      if (callback) {
        process.nextTick(function() {
          callback(e, false);
        });
        return;
      }
      throw e;
    }
    var foundError = false;
    var report = new Report(this.options);
    if (typeof schema === "string") {
      var schemaName = schema;
      schema = SchemaCache.getSchema.call(this, report, schemaName);
      if (!schema) {
        throw new Error("Schema with id '" + schemaName + "' wasn't found in the validator cache!");
      }
    } else {
      schema = SchemaCache.getSchema.call(this, report, schema);
    }
    var compiled = false;
    if (!foundError) {
      compiled = SchemaCompilation.compileSchema.call(this, report, schema);
    }
    if (!compiled) {
      this.lastReport = report;
      foundError = true;
    }
    var validated = false;
    if (!foundError) {
      validated = SchemaValidation.validateSchema.call(this, report, schema);
    }
    if (!validated) {
      this.lastReport = report;
      foundError = true;
    }
    if (options.schemaPath) {
      report.rootSchema = schema;
      schema = get(schema, options.schemaPath);
      if (!schema) {
        throw new Error("Schema path '" + options.schemaPath + "' wasn't found in the schema!");
      }
    }
    if (!foundError) {
      JsonValidation.validate.call(this, report, schema, json);
    }
    if (callback) {
      report.processAsyncTasks(this.options.asyncTimeout, callback);
      return;
    } else if (report.asyncTasks.length > 0) {
      throw new Error("This validation has async tasks and cannot be done in sync mode, please provide callback argument.");
    }
    this.lastReport = report;
    return report.isValid();
  };
  ZSchema.prototype.getLastError = function() {
    if (this.lastReport.errors.length === 0) {
      return null;
    }
    var e = new Error();
    e.name = "z-schema validation error";
    e.message = this.lastReport.commonErrorMessage;
    e.details = this.lastReport.errors;
    return e;
  };
  ZSchema.prototype.getLastErrors = function() {
    return this.lastReport && this.lastReport.errors.length > 0 ? this.lastReport.errors : undefined;
  };
  ZSchema.prototype.getMissingReferences = function(arr) {
    arr = arr || this.lastReport.errors;
    var res = [],
        idx = arr.length;
    while (idx--) {
      var error = arr[idx];
      if (error.code === "UNRESOLVABLE_REFERENCE") {
        var reference = error.params[0];
        if (res.indexOf(reference) === -1) {
          res.push(reference);
        }
      }
      if (error.inner) {
        res = res.concat(this.getMissingReferences(error.inner));
      }
    }
    return res;
  };
  ZSchema.prototype.getMissingRemoteReferences = function() {
    var missingReferences = this.getMissingReferences(),
        missingRemoteReferences = [],
        idx = missingReferences.length;
    while (idx--) {
      var remoteReference = SchemaCache.getRemotePath(missingReferences[idx]);
      if (remoteReference && missingRemoteReferences.indexOf(remoteReference) === -1) {
        missingRemoteReferences.push(remoteReference);
      }
    }
    return missingRemoteReferences;
  };
  ZSchema.prototype.setRemoteReference = function(uri, schema) {
    if (typeof schema === "string") {
      schema = JSON.parse(schema);
    } else {
      schema = Utils.cloneDeep(schema);
    }
    SchemaCache.cacheSchemaByUri.call(this, uri, schema);
  };
  ZSchema.prototype.getResolvedSchema = function(schema) {
    var report = new Report(this.options);
    schema = SchemaCache.getSchema.call(this, report, schema);
    schema = Utils.cloneDeep(schema);
    var visited = [];
    var cleanup = function(schema) {
      var key,
          typeOf = Utils.whatIs(schema);
      if (typeOf !== "object" && typeOf !== "array") {
        return;
      }
      if (schema.___$visited) {
        return;
      }
      schema.___$visited = true;
      visited.push(schema);
      if (schema.$ref && schema.__$refResolved) {
        var from = schema.__$refResolved;
        var to = schema;
        delete schema.$ref;
        delete schema.__$refResolved;
        for (key in from) {
          if (from.hasOwnProperty(key)) {
            to[key] = from[key];
          }
        }
      }
      for (key in schema) {
        if (schema.hasOwnProperty(key)) {
          if (key.indexOf("__$") === 0) {
            delete schema[key];
          } else {
            cleanup(schema[key]);
          }
        }
      }
    };
    cleanup(schema);
    visited.forEach(function(s) {
      delete s.___$visited;
    });
    this.lastReport = report;
    if (report.isValid()) {
      return schema;
    } else {
      throw this.getLastError();
    }
  };
  ZSchema.prototype.setSchemaReader = function(schemaReader) {
    return ZSchema.setSchemaReader(schemaReader);
  };
  ZSchema.prototype.getSchemaReader = function() {
    return ZSchema.schemaReader;
  };
  ZSchema.setSchemaReader = function(schemaReader) {
    ZSchema.schemaReader = schemaReader;
  };
  ZSchema.registerFormat = function(formatName, validatorFunction) {
    FormatValidators[formatName] = validatorFunction;
  };
  ZSchema.unregisterFormat = function(formatName) {
    delete FormatValidators[formatName];
  };
  ZSchema.getRegisteredFormats = function() {
    return Object.keys(FormatValidators);
  };
  ZSchema.getDefaultOptions = function() {
    return Utils.cloneDeep(defaultOptions);
  };
  module.exports = ZSchema;
})(require('process'));
